import { useSidebar } from '../../hooks/useSidebar';

const SidebarOverlay = () => {
    const { isOpen, toggleSidebar } = useSidebar();

    const handleOverlayClick = () => {
        toggleSidebar();
    };

    return (
        <div
            className={`sidebar-overlay ${isOpen ? 'active' : ''}`}
            onClick={handleOverlayClick}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                zIndex: 9995,
                opacity: isOpen ? 1 : 0,
                pointerEvents: isOpen ? 'auto' : 'none',
                transition: 'opacity 0.2s ease',
                display: 'none', // Overridden by media query in Sidebar.css
            }}
        />
    );
};

export default SidebarOverlay;
